module.exports = __webpack_public_path__ + "img/other_11.b47cfda2.png";